export enum autorizadorEnum {
    "VISA" = 1,
    "MASTERCARD" = 2,
    "AMERICAN EXPRESS" = 3,
    "MULTICHECK" = 4,
    "HIPER" = 5,
    "AURA" = 6,
    "ITAÚ SHOPLINE" = 7,
    "BRADESCO TRANSFERÊNCIA" = 8,
    "BANCO IBI" = 9,
    "CABAL" = 12,
    "POLICARD" = 13,
    "BIGCARD" = 15,
    "SUPERCARD" = 16,
    "EXCARD" = 17,
    "EDMCARD" = 18,
    "COOPER CARD" = 19,
    "CREDMAIS" = 20,
    "DACASA" = 21,
    "CREDISHOP" = 22,
    "OBOÉ" = 23,
    "SMARTSHOP" = 24,
    "ACCREDITO" = 25,
    "COOPLIFE" = 26,
    "PAGGO" = 27,
    "VALECARD" = 28,
    "SOROCRED" = 29,
    "MAXICRED" = 30,
    "CREDSYSTEM" = 31,
    "TREDENEXX" = 32,
    "DINERS" = 33,
    "BANESE" = 34,
    "SICREDI" = 35,
    "MULTIALIMENTAÇÃO" = 36,
    "MULTICASH" = 37,
    "ICARDSPL" = 38,
    "FORTBRASIL" = 40,
    "ELO" = 41,
    "GOODCARD" = 42,
    "JCB" = 43,
    "DISCOVER" = 44,
    "CHINA UNION PAY" = 45,
    "CREDZ" = 46,
    "AGIPLAN" = 47,
    "VEROCHEQUE" = 48,
    "SAVEGNAGO" = 49,
    "MASTERCARD ALIMENTAÇÃO" = 50,
    "MASTERCARD REFEIÇÃO" = 51,
    "TRICARD" = 52,
    "ABASTECE AÍ" = 53,
    "PERSONAL CARD" = 59,
    "MUFFATO" = 60,
    "BRASILCARD" = 61,
    "RIACHUELO PRIVATE LABEL" = 62,
    "TICKET REFEIÇÃO" = 70,
    "TICKET ALIMENTAÇÃO" = 71,
    "TICKET CAR" = 72,
    "TICKET CULTURA" = 73,
    "TICKET FLEX" = 74,
    "TICKET SUPERFLEX" = 75,
    "BRADESCO BOLETO" = 81,
    "BRADESCO CARTÃO" = 82,
    "BRADESCO FINANCIAMENTO" = 83,
    "MARISA PRIVATE LABEL" = 86,
    "WAPPA REFEIÇÃO" = 100,
    "WAPPA ALIMENTAÇÃO" = 101,
    "BRADESCARD PRIVATE LABEL" = 115,
    "COMPCARD" = 116,
    "PAN" = 122,
    "CARTÃO PRESENTE MARISA" = 127,
    "ORBITALL" = 160,
    "E-COMMERCE PERNAMBUCANAS" = 161,
    "CLUB+" = 162,
    "CARTÃO VUON PRIVATE LABEL" = 163,
    "AVISTA CREDITO" = 192,
    "CAMPEÃO PRIVATE LABEL" = 193,
    "VISA PRIVATE LABEL" = 201,
    "MASTERCARD PRIVATE LABEL" = 202,
    "PEELA (GIFT)" = 203,
    "RENNER REALIZE" = 206,
    "VR ALIMENTAÇÃO" = 207,
    "VR REFEIÇÃO" = 209,
    "VR AUTO" = 210,
    "VR CULTURA" = 211,
    "HUG (GIFT)" = 218,
    "VISA ELECTRON (DÉBITO)" = 221,
    "VISA PRÉ-PAGO" = 222,
    "ALELO CULTURA" = 223,
    "ALELO REFEIÇÃO" = 224,
    "ALELO ALIMENTAÇÃO" = 225,
    "COOPERCARD CULTURA" = 245,
    "COOPERCARD ALIMENTAÇÃO" = 246,
    "COOP FACIL PRIVATE LABEL" = 250,
    "CASSOL PRIVATE LABEL" = 266,
    "EXTRABOM" = 267,
    "VERDECARD PRIVATE LABEL" = 271,
    "SODEXO VALE CULTURA" = 279,
    "SODEXO VALE ALIMENTAÇÃO" = 280,
    "SODEXO VALE REFEIÇÃO" = 281,
    "SODEXO GIFT" = 282,
    "SODEXO PREMIUM" = 283,
    "SODEXO COMBUSTÍVEL" = 284,
    "BANESCARD" = 285,
    "MASTERCARD DÉBITO" = 286,
    "KOERICH" = 287,
    "ELO DÉBITO" = 288,
    "VALECARD VOUCHER" = 289,
    "SAFETYPAY" = 300,
    "PAYPAL" = 400,
    "BCASH" = 401,
    "MERCADO PAGO" = 402,
    "BANCO DO BRASIL BOLETO" = 404,
    "GOOGLE PAY" = 405,
    "VISA CHECKOUT" = 406,
    "MASTER PASS" = 407,
    "BANCO DO BRASIL TRANSFERÊNCIA" = 408,
    "ALELO AUTO" = 409,
    "SAMSUNG PAY" = 410,
    "BANRI COMPRAS À VISTA" = 411,
    "BANRI COMPRAS PARCELADO" = 412,
    "BANRI COMPRAS PRÉ-DATADO" = 413,
    "CASA SHOW" = 414,
    "BANCO DO BRASIL DÉBITO PF" = 415,
    "BANCO DO BRASIL DÉBITO PF E PJ" = 416,
    "BANCO DO BRASIL CREDIÁRIO" = 417,
    "SENFF" = 430,
    "VEE" = 431,
    "BRASIL CONVÊNIOS" = 434,
    "PIX" = 440,
    "VEGAS CARD CRÉDITO" = 441,
    "VEGAS CARD DÉBITO" = 442,
    "VEGAS CARD ALIMENTAÇÃO" = 443,
    "VEGAS CARD REFEIÇÃO" = 444,
    "BRADESCARD VOUCHER" = 445,
  }